import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import { App } from './App';
import { FIXTURE_MODE, installMock } from './mock/install';

async function boot() {
  if (FIXTURE_MODE) await installMock();
  createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
}

void boot();
